/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import { SET_LIST } from "./mutation-types";

/* eslint-disable no-param-reassign */
export default {
    [SET_LIST](state, data) {
        
        localStorage.setItem(data.key, data.value);

        state[data.key] = data.value;
    }
};
